// ¿Hay un golden ticket sin canjear en pantalla?
//
// Existe por una sola razón: el chatbot de las demos pide scroll cada vez que
// termina de escribirse un mensaje, y eso arrastra la vista fuera de la tarjeta
// del ticket a los dos segundos de llegar. Quien escaneó el QR aterriza, ve su
// ticket un instante y la página se lo lleva.
//
// Mientras la bandera esté arriba, las demos no mueven el scroll. Se apaga en
// cuanto el ticket se canjea o resulta no servir, y entonces la demo vuelve a
// comportarse exactamente como siempre. Sin ticket nunca se prende, así que
// para todo el mundo que no venga de un QR no cambia nada.
let visible = false;

export const marcarTicketVisible = (valor) => {
  visible = !!valor;
};

export const hayTicketVisible = () => visible;
